import * as FluxUtils from 'flux/utils';

import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';

import { Payload } from '../utils/OpenID';

export interface CustomLoginUserInfo extends Payload {
    [id: string]: string | number;
}

export interface CustomLoginStoreState {
    userInfo: CustomLoginUserInfo | null;
}

class CustomLoginStoreClass extends FluxUtils.ReduceStore<CustomLoginStoreState, unknown> {
    public getInitialState(): CustomLoginStoreState {
        return {
            userInfo: null
        };
    }

    public reduce(state: CustomLoginStoreState, action: DispatcherBaseAction): CustomLoginStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.CUSTOM_LOGIN_LOGOUT:
                return jQuery.extend({}, this.getInitialState());
            case ActionConstants.CUSTOM_LOGIN_SET_USERINFO:
                return jQuery.extend({}, state, {
                    userInfo: action.value
                });
            default:
                break;
        }

        return state;
    }
}

export let CustomLoginStore: CustomLoginStoreClass = new CustomLoginStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/CustomLoginStore.ts